import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyToClipboardComponent } from './copy-to-clipboard.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [CopyToClipboardComponent],
  imports: [CommonModule, MatTooltipModule],
  exports: [CopyToClipboardComponent],
})
export class CopyToClipboardModule {}
